"use client"

import { useState, useEffect } from "react"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import Header from "./components/Header"
import Home from "./components/Home"
import Skills from "./components/Skills"
import Experience from "./components/Experience"
import Education from "./components/Education"
import Projects from "./components/Projects"
import Activities from "./components/Activities"
import CherishedOne from "./components/CherishedOne"
import Contact from "./components/Contact"
import Footer from "./components/Footer"
import Loader from "./components/Loader"
import { useToastNotifications } from "./hooks/useToastNotifications"
import ScrollToTopButton from "./components/scrolltotop"
import NewPortfolioModal from "./components/NewPortfolioModal"

function App() {
  const [loading, setLoading] = useState(true)

  useToastNotifications()

  useEffect(() => {
    const hasShownToast = sessionStorage.getItem("welcomeToastShown")

    const timer = setTimeout(() => {
      setLoading(false)

      if (!hasShownToast) {
        sessionStorage.setItem("welcomeToastShown", "true")

        setTimeout(() => {
          toast.success("Welcome to my Portfolio!! 💻", {
            position: "bottom-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
              fontFamily: "Poppins, sans-serif",
              fontSize: "1.4rem",
            },
          })
        }, 500)
      }
    }, 1000)

    return () => clearTimeout(timer)
  }, [])

  if (loading) {
    return <Loader />
  }

  return (
    <div className="bg-bg-primary text-text-primary">
      <NewPortfolioModal />
      <Header />
      <Home />
      <Skills />
      <Experience />
      <Education />
      <Projects />
      <Activities />
      <CherishedOne />
      <Contact />
      <Footer />
      <ScrollToTopButton />
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
    </div>
  )
}

export default App
